import { RecommendationItemDesktop } from './RecommendationItemDesktop';
import { RecommendationItemMobile } from './RecommendationItemMobile';
import React, { useCallback } from 'react';
import { RecommendationData } from './useRecommendation';
import { PROVIDERS_PROVIDER_BIO } from 'utilities/routes';
import { useNavigate } from 'react-router-dom';
import { useCustomToast } from 'layout/useToast';

interface IRecommendationItem {
  recommendation: RecommendationData;
  locale: Record<string, string>;
  isArchive?: boolean;
  addRecommendationToCart: (
    productId: number,
    quantity: number,
    recommendationId: string,
  ) => Promise<unknown>;
  moveToArchive?: () => Promise<unknown>;
  deleteRecommendation?: () => Promise<unknown>;
}

export const RecommendationItem: React.FC<IRecommendationItem> = ({
  recommendation,
  locale,
  isArchive = false,
  addRecommendationToCart,
  moveToArchive,
  deleteRecommendation,
}) => {
  const navigate = useNavigate();
  const { addToast } = useCustomToast();

  const handlePurchase = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    await addRecommendationToCart(
      recommendation.productId,
      recommendation.quantity,
      recommendation.id,
    );
    addToast({ type: 'success', message: 'Recommendation added to cart' });
  };

  const handleProviderClick = useCallback(() => {
    return navigate(PROVIDERS_PROVIDER_BIO, {
      state: { providerId: recommendation.providerCodexId },
    });
  }, [recommendation.providerCodexId, navigate]);

  const classNames = !isArchive
    ? 'rounded-10 bg-base-content w-full border border-graph-border-color py-4 px-5'
    : 'rounded-10 bg-white w-full border border-graph-border-color py-4 px-5';

  return (
    <>
      <RecommendationItemDesktop
        recommendation={recommendation}
        locale={locale}
        purchaseRecommendation={handlePurchase}
        moveToArchive={moveToArchive}
        deleteRecommendation={deleteRecommendation}
        handleNameClick={handleProviderClick}
        containerClassNames={classNames}
        showImage
      />
      <RecommendationItemMobile
        recommendation={recommendation}
        locale={locale}
        purchaseRecommendation={handlePurchase}
        moveToArchive={moveToArchive}
        showImage
        handleNameClick={handleProviderClick}
        deleteRecommendation={deleteRecommendation}
        containerClassNames={classNames}
      />
    </>
  );
};
